import {I18nString} from "@/i18n/i18nString";

export interface Activity {
    name: I18nString
    title: I18nString
    md?: string | (() => Promise<string | typeof import("*.md")>) // 通常是通过异步require引入一个markdown文件。（利用了markdown-loader包，实际上require markdown文件得到的就是一段html字符串，因此理论上，这里填写markdown字符串也是没有任何问题的）
    href?: string
    abstract?: I18nString
    img?: string
    tag?: { content: I18nString, color: string }
}


function state() {
    const activities: Activity[] = [
        {
            name: {
                en: "CCF GML 2026 Forum: Hypergraph Computation Theory and Applications",
                zh: "2026 CCF 图机器学习会议分论坛：超图计算理论及应用"
            },
            title: {
                en: "Hypergraph Computation Theory and Applications",
                zh: "超图计算理论及应用"
            },
            md: () => import('../data/activity/CCF2026Changchun.md'),
            img: require("../assets/img/ccf2026changchun/ccf2026.png"),
        },
        {
            name: {
                "en": "ICME 2026 Special Session: Graph-Driven Cognitive Intelligence for Multimedia Understanding and Interaction",
                "zh": "ICME 2026 专题论坛：面向多媒体理解与交互的图驱动认知智能"
            },
            title: "ICME 2026 Special Session", 
            md: () => import('../data/activity/2026-icme-specialsession.md'),
            img: require("../assets/img/icme2026/icme2026.png"),
        },
        {
            name: {
                "en": "MICCAI 2025 Workshop Track: Hypergraph Computation for Medical Image Analysis",
                "zh": "MICCAI 2025 论坛: 超图计算在医学图像分析中的应用"
            },
            title: "MICCAI 2025 Workshop: GRAIL",
            md: () => import(/* webpackChunkName: "shrec22" */ '../data/activity/MICCAI2025workshop.md'),
            img: require("../assets/research/miccai2025-logo.png"),
        },
        {
            name: {
                "en": "MICCAI 2025 Tutorial: 3rd Graph Learning in Medical Image Analysis (GraphMedIA)",
                "zh": "MICCAI 2025 讲习班: 医学图像分析中的图学习"
            },
            title: "MICCAI 2025 Tutorial: GraphMedIA",
            md: () => import(/* webpackChunkName: "shrec22" */ '../data/activity/MICCAI2025tutorial.md'),
            img: require("../assets/research/miccai2025-logo.png"),
        },

        {
            name: {
                "en": "Special Issue of Pattern Recognition: Graph Foundation Model for Medical Image Analysis",
                "zh": "模式识别特刊征稿：图基础模型在医学图像分析中的应用"
            },
            title: "Pattern Recognition Special Issue",
            md: () => import(/* webpackChunkName: "shrec22" */ '../data/activity/PRSI.md'),
            img: require("../assets/research/PRSI.png"),
        },

        {
            name: {
                "en": "SHREC 2022 Track: Open-Set 3D Object Retrieval",
                "zh": "SHREC 2022 赛道：开集3D物体检索"
            },
            title: {
                "en": "The objective of this track is to evaluate the performance of the different 3D shape retrieval algorithms under the Open-Set setting, which is an unknown-category shape retrieval task.",
                "zh": "本赛道的目的是评估不同3D形状检索算法在开放集设置下的性能。"
            },
            md: () => import(/* webpackChunkName: "shrec22" */ '../data/activity/shrec22.md'),
            img: require("../assets/activity/shrec22.png"),
        },
    ]
    return activities
}

export default state()
